<script>
import { services } from '@utils/common-services'
export default {
  props: {
    validation: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-default-prop
    options: {
      type: Object,
      default() {
        return {}
      },
    },

    // eslint-disable-next-line vue/require-prop-types
    value: {
      type: Object,
      default() {
        return null
      },
    },
    label: {
      type: String,
      default() {
        return ''
      },
    },
    form: {
      type: String,
      default() {
        return ''
      },
    },
    name: {
      type: String,
      required: true,
    },
    user: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default() {
        return 'date'
      },
    },
    // Only allow types that essentially just render text boxes.
  },
  data() {
    return {
      files: null,
      userName: null,
      date:
        new Date().getDate() +
        '-' +
        (new Date().getMonth() + 1) +
        '-' +
        new Date().getFullYear(),
      agreed: null,
      declaration: {},
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (this.value !== null)
        if (this.value.agreed !== undefined && this.value.agreed !== null)
          this.setSavedValue()
    },
  },
  beforeMount() {
    this.getUserName()
  },
  beforeDestroy() {
    var doc = this.$refs.declaration
    if (doc !== undefined) doc.innerHTML = ''
  },
  mounted() {
    if (this.value !== null)
      if (this.value.agreed !== undefined && this.value.agreed !== null)
        this.setSavedValue()
      else this.getUserName()
  },
  methods: {
    setSavedValue() {
      this.agreed = this.value.agreed
      this.readSignature(this.value.signature, false)
      this.date = this.value.date
      this.userName = this.value.name
    },
    getUserName() {
      var details = JSON.parse(services.getLocalStorage('user'))

      if (details.applicant1.id === this.user)
        this.userName = details.applicant1.fullName
      else {
        if (details.applicant2 !== undefined)
          if (details.applicant2.id === this.user)
            this.userName = details.applicant2.fullName
      }
    },
    readSignature(data, save) {
      this.files = data
      this.agreed = true
      var src = 'data:image/jpeg;base64,'
      src += data
      var newImage = document.getElementById('declaration-signature')
      newImage.src = src
      newImage.width = newImage.height = '80'
      if (save) {
        this.$emit('update', {
          date: this.date,
          signature: this.files,
          name: this.userName,
          agreed: this.agreed,
        })
      }
      this.$bvModal.hide('modal-signature-change', '')
    },
    agree() {
      this.$bvModal.show('modal-signature-change')

      /*   if (this.files !== null) {
        this.agreed = true
        this.$emit('update', {
          date: this.date,
          signature: this.files,
          name: this.userName,
          agreed: this.agreed,
        })
      } */
    },
  },
}
</script>
<template>
  <div ref="declaration" :class="$style.addMainWraper" class="w100">
    <div
      :class="[
        $style.addMoreWraper,
        $style.declarationWraper,
        $style.fullWidth,
      ]"
      class="mt20 mb20 100"
    >
      <div
        v-b-toggle.accordion-1
        :class="$style.addMoreCardHeader"
        variant="info"
      >
        <h4 :class="$style.cardTitle" class="FL">Declaration </h4>
        <div :class="$style.collapseActions" class="FR tc">
          <a
            id="delete"
            href="javascript:void(0)"
            :class="[$style.removeCollapse, $style.collapseActionButton]"
            ><BIcon class="" icon="chevron-right"></BIcon>
          </a>
        </div>
        <div class="clear"></div>
      </div>
      <b-collapse
        id="accordion-1"
        accordion="my-accordion"
        role="tabpanel"
        visible
      >
        <div :class="$style.declarationCardBody">
          <p :class="[$style.cardData, $style.addressIcon]" class="mb20"
            >Please sign to confirm that all the information you have provided
            within this form is true and accurate. The application form is a
            significant tool in the assessment of foster carers and information
            contained within will be considered and assessed in accordance with
            the Fostering Regulations 2011 and the Miscellaneous Amendments
            2013, National Minimum Standards 2011 and the Care Planning, Looked
            After Children (Scotland) Regulations 2009, Placement and Case
            Review Regulations 2010/13, and Safer Recruitment Practices.
          </p>
          <p :class="[$style.cardData, $style.addressIcon]" class="mb20">
            I/we undertake to be truthful and honest in providing full and
            accurate information for this assessment, both verbally and in
            writing. I/we understand that the fostering service may seek
            verification of any information that I/we have supplied or will
            supply, and that if any of this information is found to be false or
            misleading, this may result in the fostering service deciding not to
            proceed with my/our application.
          </p>
          <p :class="[$style.cardData, $style.addressIcon]" class="mb20">
            I/we understand that the fostering service will be taking up a
            series of checks and references and will be seeking our consent to
            do this. I/we understand that if we are not willing to consent to
            these checks and references being undertaken the fostering service
            may decide not to progress with my/our application.
          </p>
          <p :class="[$style.cardData, $style.addressIcon]" class="mb20"
            >I consent to Swiis Foster Care Limited processing my personal and
            sensitive data for the following purposes:
          </p>
          <ul>
            <li>
              For Swiis Foster Care Limited to provide me with the opportunity
              to either become an approved foster carer or continue approval as
              a foster carer or to act as a support carer or to support a
              prospective or an approved foster carer as a member of their
              household with Swiis Foster Care Limited.
            </li>
            <li>
              For Swiis Foster Care Limited to meet the requirements of law and
              regulations pertaining to fostering and supporting children and
              young people looked after.
            </li>
            <li
              >For Swiis Foster Care Limited to process my data on a
              computerised database provided by Social Care Network (CHARMS) to
              provide me with the opportunity to either become an approved
              foster carer or continue approval as a foster carer or to act as a
              support carer or to support a prospective or an approved foster
              carer as a member of their household with Swiis Foster Care
              Limited.</li
            >
            <p :class="[$style.cardData, $style.addressIcon]" class="mb20">
              I also consent to Swiis Foster Care Limited processing and sharing
              my personal data with third parties including OFSTED, Care
              Inspectorate, and Local Authorities for the purposes of finding
              suitable placements and internal and external audits and
              investigations carried out on Swiis Foster Care Limited to ensure
              that Swiis Foster Care Limited is complying with all relevant
              laws, regulations and contract obligations.
            </p>
            <p :class="[$style.cardData, $style.addressIcon]" class="mb20">
              I also consent to Swiis Foster Care Limited requesting on my
              behalf my personal and sensitive data from third parties to
              provide me with the opportunity either become an approved foster
              carer or continue approval as a foster carer or to act as a
              support carer or to support a prospective or an approved foster
              carer as a member of their household with Swiis Foster Care
              Limited.
            </p>
            <p :class="[$style.cardData, $style.addressIcon]" class="mb20">
              The consent I give to Swiis Foster Care Limited will last for the
              duration of my application or approval. I am aware that I have the
              right to withdraw my consent at any time by informing Swiis Foster
              Care Limited that I wish to do so. Withdrawing your consent will
              result in you no longer being able to foster.
            </p>
            <p :class="[$style.cardData, $style.addressIcon]" class="mb20">
              I/we give Swiis permission to undertake medical records checks,
              Local Authority checks, School/Health Visitor Checks on my
              children, previous fostering provider checks, employment and
              personal references, ex-partner references and any other check
              deemed appropriate to support this application.
            </p>
            <p :class="[$style.cardData, $style.addressIcon]" class="mb20">
              I/we can confirm that we have read the privacy notice on the Swiis
              website:
              <a
                href="https://www.swiisfostercare.com/privacy/"
                target="_blank"
                class="linkText dib"
              >
                https://www.swiisfostercare.com/privacy/
              </a>
              (England) and
              <a
                href="https://www.swiisfostercarescotland.com/privacy/"
                target="_blank"
                class="linkText dib"
              >
                https://www.swiisfostercarescotland.com/privacy/
              </a>
              (Scotland)
            </p>
          </ul>
          <div class="clear"></div>
          <button
            :class="
              agreed
                ? [$style.agreeButton, $style.agreed]
                : [$style.agreeButton]
            "
            class="FL mb10"
            type="button"
            @click="agree"
          >
            <BIcon
              :class="$style.agreeIcon"
              class="mr5"
              icon="check-circle-fill"
            ></BIcon
            >I Agree</button
          >
          <div class="FR">
            <h6 :class="$style.subTitle" class="FL mr10"
              ><BIcon class="mr5" icon="person-fill"></BIcon>{{ userName }}</h6
            >
            <h6 :class="$style.subTitle" class="FL mr10"
              ><BIcon class="mr5" icon="calendar-fill"></BIcon>{{ date }}</h6
            >
            <div class="clear"></div>
            <!-- Add Signature -->
            <!--  <button
              v-show="files === null"
              :class="[$style.signatureButton]"
              class="FR"
              @click="$bvModal.show('modal-signature-change')"
            >
              <b>+</b> Signature
            </button> -->
            <div class="clear"></div>
            <div
              v-show="files !== null"
              :class="$style.signatureWraper"
              class="FR ml10"
            >
              <div :class="$style.signatureImageWraper" class="FL p5 mr10">
                <img
                  v-show="files !== null"
                  id="declaration-signature"
                  :class="$style.signatureImage"
                  src=""
                  alt="your signature"
                />
              </div>
              <a
                href="javascript:void(0)"
                :class="$style.actionsBtn"
                class="FR mt10"
                @click="$bvModal.show('modal-signature-change')"
                ><BIcon
                  icon="arrow-repeat"
                  :class="$style.actionIcon"
                  class="font14"
                ></BIcon>
              </a>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
          <span v-if="!agreed" :class="$style.declarationNotice" class="mt10"
            ><BIcon class="mr5" icon="info-circle"></BIcon>You have to add
            signature to agree the terms and condition.</span
          >
        </div>
      </b-collapse>
    </div>
    <b-modal
      id="modal-signature-change"
      centered
      title="BootstrapVue"
      hide-header
      hide-footer
      size="md"
      :class="$style.modalOverall"
    >
      <div :class="$style.modalWraper">
        <div :class="$style.modalHeader">
          <h3 :class="$style.modalTitle">Update signature</h3>
          <a
            href="javascript:void(0)"
            :class="$style.modalClose"
            @click="$bvModal.hide('modal-signature-change')"
          >
            <BIcon class="" icon="x" :class="$style.modalCloseIcon"></BIcon>
          </a>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
        <div :class="$style.modalBody">
          <FormBaseSignature @base="readSignature($event, true)" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.declarationNotice {
  font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 14px;
  color: #e8371f;
}
// Add more wraper set
.addMainWraper {
  .addMoreWraper {
    position: relative;
    width: 90%;
    overflow: hidden;
    background: #fff;
    border: 1px solid #f2f2f2;
    border-radius: 10px;

    .addMoreCardHeader {
      position: relative;
      padding: 15px 15px 15px 35px;
      cursor: pointer;
      background: #fafafa;
      border-bottom: 1px solid #f2f2f2;

      &::after {
        position: absolute;
        top: 18px;
        left: 12px;
        width: 15px;
        height: 15px;
        content: '';
        background: #fdc360;
        border-radius: 50px;
      }
    }

    .declarationCardBody {
      padding: 15px 15px 40px;

      ul li {
        position: relative;
        display: block;
        padding-left: 25px;
        margin-bottom: 15px;
        font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
          Apple Color Emoji;
        font-size: 14px;
        color: #919394;

        &::after {
          position: absolute;
          top: 3px;
          left: 4px;
          width: 14px;
          height: 14px;
          content: '';
          background: #fdc360;
          border-radius: 50px;
        }
      }
    }

    &.declarationWraper {
      .cardData {
        position: relative;
        margin-bottom: 15px;
        font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
          Apple Color Emoji;
        font-size: 14px;
        color: #919394;
      }
    }

    &.fullWidth {
      width: 100% !important;
    }

    .collapseActions {
      .collapseActionButton {
        position: relative;
        display: inline-block;
        width: 23px;
        height: 23px;
        padding: 4px;
        margin-right: 5px;
        font-size: 12px;
        color: #ff5c16 !important;
        background: #fff;
        border: 1px solid #fba47f;
        border-radius: 50px;
        transition: all 0.2s ease;
        svg {
          display: block;
        }
        &:hover {
          color: #fff !important;
          background: #ff5d15 !important;
          border-color: #ff5d15 !important;
          transition: all 0.2s ease;
        }
      }
      &:last-child {
        margin-right: 0 !important;
      }
    }

    .cardTitle {
      margin: 0;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 15px;
      line-height: 20px;
      color: $color-field-text;
    }
  }
}
// Add more wraper set

.agreeButton {
  padding: 6px 20px;
  font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
  font-size: 15px;
  color: #aaacb0;
  background: #fff;
  border: 1px solid #aaacb0;
  border-radius: 50px;

  &.agreed {
    color: #60e8bb;
    pointer-events: none;
    border-color: #60e8bb;
  }
}

.signatureButton {
  padding: 6px 20px;
  font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
  font-size: 15px;
  color: #aaacb0;
  background: #fff;
  border: 1px solid #aaacb0;
  border-radius: 50px;
}

.signatureWraper {
  .signatureImageWraper {
    width: 110px;
    height: 47px;
    overflow: hidden;
    font-size: 13px;
    line-height: 35px;
    color: #bfbbbb;
    text-align: center;
    background: #f8f8f8;
    border: 1px solid #ebebeb;
    border-radius: 5px;

    .signatureImage {
      float: left;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.actionsBtn {
  position: relative;
  display: block;
  width: 26px;
  height: 26px;
  color: #455d73;
  background: #fff !important;
  border: 1px solid #455d73 !important;
  border-radius: 50px !important;

  .actionIcon {
    position: absolute;
    top: 5px;
    left: 5px;
    color: #455d73;
    transition: all ease-in-out;
    transform: rotate(0deg) 0.2s;
  }

  &.animate:hover {
    .actionIcon {
      color: #455d73;
      transition: all ease-in-out 0.2s;
      transform: rotate(90deg);
    }
  }
}

// Modal
.modalOverall {
  padding: 0;
}
.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalClose {
    position: relative;
    display: block;
    float: right;
    width: 32px;
    height: 32px;
    font-size: 23px;
    line-height: 30px;
    color: #8b8d90;
    text-align: center;
    background: #eceff1;
    border-radius: 50px;

    .modalCloseIcon {
      position: absolute;
      top: 4px;
      left: 5px;
    }
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .modalfooter {
    padding-top: 30px;
    padding-bottom: 10px;
  }
}
// Modal

.subTitle {
  font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
  font-size: 14px;
  color: #919394;
}

.form {
  padding: 20px 30px;
}
</style>
